import React, { useCallback, useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import styles from "./AssemblyVotingList.module.css";
import { IVoting } from "src/stores/assemblies/VotingStore";

interface IAssemblyVotingListBase {
    agendaitemId?: string;
}

const AssemblyVotingListBase = observer((props: IAssemblyVotingListBase) => {
    const { votingStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    useEffect(() => {
        if (props.agendaitemId) {
            votingStore.loadAllVotingsByAgendaItemId(props.agendaitemId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.agendaitemId]);

    const onClickVoting = useCallback(
        (voting: IVoting) => () => {
            votingStore.setSelectedVoting(voting);
        },
        [votingStore]
    );

    if (votingStore.votingList.length <= 1) {
        return null;
    }

    return (
        <UI.Card className={styles.Card}>
            <div className={styles.VotingTitle}>{t("screens.assemblies.livemode.voting").toString()}</div>
            <div className={styles.VotingList}>
                {votingStore.votingList.map((voting, index) => (
                    <div
                        key={voting.votingid}
                        className={
                            voting.votingid === votingStore.selectedVoting.votingid
                                ? styles.SelectedVoting
                                : styles.VotingItem
                        }
                        onClick={onClickVoting(voting)}
                    >
                        {index + 1}. {t("screens.assemblies.vote.voting")}: {voting.title}
                    </div>
                ))}
            </div>
        </UI.Card>
    );
});

export const AssemblyVotingList = Sentry.withProfiler(AssemblyVotingListBase);
